import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import DropDownComponent from "../DropDownComponent";
import InputComponent from "../InputComponent";
import TextFieldComponentLarge from "../TextFieldComponentLarge";
import RatingComponent from "../RatingComponent";
import TopTitleFormComponent from "./TopTitleFormComponent";
import DatePickerComponent from "../DatePickerComponent";
import { useAuth } from "../../contexts/AuthContext";
import { Button } from "@mui/material";
import { db } from "../../firebase";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { showCustomToast } from "../Misc/CustomToast";
import DropDownAllStaffs from "../Dropdowns/DropDownAllStaffs";
import { StandardDrawerFooter } from "./StandardDrawer";
import "./AdmissionDocumentRedesign.css";

function EditDischargeReport(props) {
  //STATES
  const { currentUser } = useAuth();
  const [clientIdState, setClientIdState] = useState(props.clientId);
  const [isLoading, setIsLoading] = useState(false);
  const [dischargeDate, setDischargeDate] = useState(null);
  const [dischargeType, setDischargeType] = useState("");
  const [dischargeTo, setDischargeTo] = useState("");
  const [medication, setMedication] = useState("");
  const [issuesUponAdmission, setIssuesUponAdmission] = useState("");
  const [emergingIssues, setEmergingIssues] = useState("");
  const [progress, setProgress] = useState("");
  const [familyInvolvement, setFamilyInvolvement] = useState("");
  const [roadblocks, setRoadblocks] = useState("");
  const [clientPrognosis, setClientPrognosis] = useState("");
  const [dischargePlan, setDischargePlan] = useState("");
  const [staffMemberName, setStaffMemberName] = useState(
    currentUser.displayName
  );
  const [rating, setRating] = useState(0);
  const [dischargeTypeOther, setDischargeTypeOther] = useState("");
  const [dischargeToOther, setDischargeToOther] = useState("");
  const [selectedTherapist, setSelectedTherapist] = useState("");
  const [dateOfAdmission, setDateOfAdmission] = useState(
    "" || props.dateOfAdmission
  );
  const [lengthOfStay, setLengthOfStay] = useState("");

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);

      try {
        const dischargeFormsRef = collection(db, "dischargeForms");
        const dischargeFormDocRef = doc(dischargeFormsRef, clientIdState);
        const docData = await getDoc(dischargeFormDocRef);

        if (docData.exists()) {
          const data = docData.data();

          setClientIdState(data.clientIdState || props.clientId);
          setDischargeDate(data.dischargeDate || null);
          setDischargeType(data.dischargeType || "");
          setDischargeTo(data.dischargeTo || "");
          setMedication(data.medication || "");
          setIssuesUponAdmission(data.issuesUponAdmission || "");
          setEmergingIssues(data.emergingIssues || "");
          setProgress(data.progress || "");
          setFamilyInvolvement(data.familyInvolvement || "");
          setRoadblocks(data.roadblocks || "");
          setClientPrognosis(data.clientPrognosis || "");
          setDischargePlan(data.dischargePlan || "");
          setStaffMemberName(data.staffMemberName || currentUser.displayName);
          setRating(data.rating || 0);
          setDischargeTypeOther(data.dischargeTypeOther || "");
          setDischargeToOther(data.dischargeToOther || "");
          setSelectedTherapist(data.selectedTherapist || "");
          setDateOfAdmission(data.dateOfAdmission || props.dateOfAdmission);
          setLengthOfStay(data.lengthOfStay || "");
        }

        setIsLoading(false);
      } catch (error) {
        showCustomToast("Error loading data", "error");
        console.error("Error loading data:", error);
        setIsLoading(false);
      }
    };

    loadData();
  }, [
    clientIdState,
    currentUser.displayName,
    props.clientId,
    props.dateOfAdmission,
  ]);

  const handleSaveModifications = async () => {
    setIsLoading(true);

    try {
      const dischargeData = {
        dischargeDate,
        dischargeTypeOther,
        dischargeType,
        dischargeTo,
        dischargeToOther,
        medication,
        issuesUponAdmission,
        emergingIssues,
        progress,
        familyInvolvement,
        roadblocks,
        clientPrognosis,
        dischargePlan,
        staffMemberName,
        selectedTherapist,
        rating,
        lengthOfStay,
        dateOfAdmission,
      };

      const dischargeFormsRef = collection(db, "dischargeForms");
      const dischargeFormDocRef = doc(dischargeFormsRef, clientIdState);

      await updateDoc(dischargeFormDocRef, dischargeData);

      showCustomToast("Modifications saved successfully!", "success");

      setIsLoading(false);
      props.closemodal();
    } catch (error) {
      showCustomToast("Error saving modifications", "error");
      console.error("Error saving modifications:", error);
      setIsLoading(false);
    }
  };

  const clientDisplayName =
    [props.firstName, props.lastName].filter(Boolean).join(" ") ||
    props.clientName ||
    "Client";

  return (
    <>
      <div className="admission-document-shell admission-card-form-shell">
        <TopTitleFormComponent
          title="Discharge summary / Report"
          eyebrow="ADMISSION FORM"
          subtitle={clientDisplayName}
          closemodal={props.closemodal}
        />

        <div className="admission-document-body">
          <div className="tab-form-container">
            <DatePickerComponent
              title="Discharge date"
              width="300"
              isRequired={true}
              value={dischargeDate}
              onChange={(event) => setDischargeDate(event)}
            />

            <DropDownComponent
              api="dischargeType"
              title="Discharge type"
              isRequired={true}
              value={dischargeType}
              onChange={(event) => setDischargeType(event)}
            />

            {dischargeType === "Other" && (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={dischargeTypeOther}
                onChange={(event) => setDischargeTypeOther(event)}
              />
            )}

            <DropDownComponent
              api="dischargeTo"
              title="Discharge to"
              value={dischargeTo}
              isRequired={true}
              onChange={(event) => setDischargeTo(event)}
            />

            {dischargeTo === "Other" && (
              <InputComponent
                title="If other, describe"
                width="150px"
                value={dischargeToOther}
                onChange={(event) => setDischargeToOther(event)}
              />
            )}
          </div>

          <div className="tab-form-container">
            <DropDownAllStaffs
              title="Assigned Therapist"
              value={selectedTherapist}
              width="auto"
              onChange={(value) => setSelectedTherapist(value)}
            />

            <DatePickerComponent
              title="Date of admission"
              width="150px"
              value={dateOfAdmission}
              // onChange={handleDateOfAdmission}
            />

            <InputComponent
              title="Total length of stay"
              width="150px"
              value={lengthOfStay}
              // onChange={(event) => setLengthOfStay(event)}
            />
          </div>

          <div className="tab-form-container">
            <TextFieldComponentLarge
              title="Medication prescribed upon discharge"
              value={medication}
              onChange={(event) => setMedication(event)}
            />
            <TextFieldComponentLarge
              title="Identified issues upon admission"
              value={issuesUponAdmission}
              onChange={(event) => setIssuesUponAdmission(event)}
            />
            <TextFieldComponentLarge
              title="Emerging issues identified during treatment"
              value={emergingIssues}
              onChange={(event) => setEmergingIssues(event)}
            />

            <RatingComponent
              value={rating}
              onChange={(event) => setRating(event)}
            />

            <TextFieldComponentLarge
              title="Progress"
              value={progress}
              onChange={(event) => setProgress(event)}
            />
            <TextFieldComponentLarge
              title="Family / significant Other Involvement"
              value={familyInvolvement}
              onChange={(event) => setFamilyInvolvement(event)}
            />
            <TextFieldComponentLarge
              title="Roadblocks/Concerns"
              value={roadblocks}
              onChange={(event) => setRoadblocks(event)}
            />
            <TextFieldComponentLarge
              title="Client prognosis"
              value={clientPrognosis}
              onChange={(event) => setClientPrognosis(event)}
            />
            <TextFieldComponentLarge
              title="Recommended Discharge Plan"
              value={dischargePlan}
              onChange={(event) => setDischargePlan(event)}
            />
            <InputComponent
              title="Staff Member Name"
              value={staffMemberName}
              // onChange={handleStaffMemberNameChange}
            />
          </div>
        </div>
        <StandardDrawerFooter className="admission-document-footer">
          <>
            <Button
              variant="contained"
              style={{ backgroundColor: "white", color: "black" }}
              onClick={props.closemodal}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSaveModifications}
              style={{
                backgroundColor: isLoading ? "lightgrey" : "#FFC107",
                color: "black",
                marginLeft: "15px",
              }}
              disabled={isLoading}
            >
              {isLoading ? "Saving Modifications..." : "Save Modifications"}
            </Button>
          </>
        </StandardDrawerFooter>
      </div>
    </>
  );
}

export default EditDischargeReport;
